import { v4 as uuidv4 } from 'uuid';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Typography, Box, Select, MenuItem, Button, FormControlLabel, Checkbox, Hidden, InputLabel, Modal, FormControl, Tooltip, Collapse} from "@mui/material";
import { SectionHeader } from "./common/section.header"
import { useExport } from '../header/useExport';
import { createSubtitle, subtitleWebHookPoll, createChatGPTSummary, getChatGPTSummary, submitChatGPTSummary, getTranscribe, getTranscribeUUid, getProjectJSON, duplicatePrjoectJSON, getSubtitleInfo, GetRegistration } from '../../../axios/ApiProvider'; 
import { GetProjectUUID } from '../../../assets/script/commonFunction';
import { ProjectJSON_Store, addedTemplate_store, changedJSON_Store } from '../../../store/actions/projectdata';
import { changeZeroSecond } from '../commonFunction';
import { VideoElements_Store } from '../../../store/actions/webgldata';
import { isAnalyzing_Store, loading_Store, stageText_Store } from '../../../store/actions/mainAction';
import { getTotalProjectTime } from '../timeline/common/commonFunction';
import PricingModal from '../../../pages/Pricing/pricingModal';
import Swal from 'sweetalert2';
import { SummaryModal } from './common/SummaryModal';
import { Slider, TextField } from '@mui/material';
import { AiShortModal } from './common/AiShortModal';

import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import AppShortcutIcon from '@mui/icons-material/AppShortcut';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import CloseIcon from '@mui/icons-material/Close';
import TuneIcon from '@mui/icons-material/Tune';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useUploadMedia } from './useUploadMedia';
import { CheckBox } from '@mui/icons-material';

const OpenAIEnabled_AIShort = false;

export const languageToList1 = [
  { label: "Turkish", key: "tr" },
  { label: "English", key: "en" },
  // { label: "Bulgarian", key: "bg" },
  { label: "Arabic", key: "ar" },
  { label: "Catalan", key: "ca" },
  { label: "Mandarin", key: "cmn" },
  { label: "Czech", key: "cs" },
  { label: "Danish", key: "da" },
  { label: "German", key: "de" },
  { label: "Greek", key: "el" },
  { label: "Spanish", key: "es" },
  { label: "Estonian", key: "et" },
  { label: "Finnish", key: "fi" },
  { label: "French", key: "fr" },
  { label: "Galician", key: "gl" },
  { label: "Hindi", key: "hi" },
  { label: "Croatian", key: "hr" },
  { label: "Hungarian", key: "hu" },
  { label: "Indonesian", key: "id" },
  { label: "Italian", key: "it" },
  { label: "Japanese", key: "ja" },
  { label: "Korean", key: "ko" },
  { label: "Lithuanian", key: "lt" },
  { label: "Latvian", key: "lv" },
  { label: "Malay", key: "ms" },
  { label: "Dutch", key: "nl" },
  { label: "Norwegian", key: "no" },
  { label: "Polish", key: "pl" },
  { label: "Portuguese", key: "pt" },
  { label: "Romanian", key: "ro" },
  { label: "Russian", key: "ru" },
  { label: "Slovakian", key: "sk" },
  { label: "Slovenian", key: "sl" },
  { label: "Swedish", key: "sv" },
  // { label: "Ukrainian", key: "uk" },
  { label: "Vietnamese", key: "vi" },
]

export const TooltapAiSummary = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const projectUUID = GetProjectUUID();
  const loginState = useSelector((store) => store.maindata.loginState)
  const [userData, setUserData] = useState({})
  const ProjectJSON = useSelector(store => store.projectdata.projectJSON);
  const [mainprojectDuration, setMainProjectDuration] = useState(0);
  const videoElements = useSelector(store => store.webgldata.videoElements);
  const HeaderInfo = { title: "AI Summary", className: 'pl-3' };
  const [aiSilence, setAiSilence] = useState(false);
  const [summaryUUID, setSummaryUUID] = useState(null);
  const [subTitlesData, setSubTitlesData] = useState(null);
  const [subtitleUUID, setSubtitleUUID] = useState(null);
  const [transcribeObj, setTranscribeObj] = useState(null);
  const [existSubtitleWords, setExistSubtitleWords] = useState([]);
  const [existSubtitleTxt, setExistSubtitleTxt] = useState('');
  const languageStrs = useSelector((store) => store.editdata.languageStrs)
  const [language, setLanguage] = useState('')
  const [languageKey, setLanguageKey] = useState('')
  const [sumaryTxtLang, setSumaryTxtLang] = useState('')
  const [sumaryTxt, setSumaryTxt] = useState('')
  const [assetUUID, setAssetUUID] = useState('');
  const uploadingFiles = useSelector((store) => store.projectdata.uploadingFiles);
  const subcreating = useSelector((store) => store.projectdata.subcreating);
  const [uploading, setUploading] = useState([])

  const [isSummary, setIsSummary] = useState(false);
  const [isCompany, setIsCompany] = useState(false);
  const [isAISummary, setIsAISummary] = useState(false);
  const [isAIShort, setIsAIShort] = useState(false);
  const [isDirectAIShort, setIsDirectAIShort] = useState(false);

  const [modalOpen, setModalOpen] = useState(false)
  const [modalData, setModalData] = useState([]);
  const [summaryData, setSummaryData] = useState({});
  const [showVideoPath, setShowVideoPath] = useState('');

  const [aiSummaryCount, setAiSummaryCount] = useState(0);
  const [aiSummaryDuration, setAiSummaryDuration] = useState(0);
  const [aiSummarySilence, setAiSummarySilence] = useState(0.5);
  const [aiShortsDuration, setAiShortsDuration] = useState(30);
  const [aiShortsNumber, setAiShortsNumber] = useState(6);
  const [projectMaxDuration, setProjectMaxDuration] = useState(0);

  const [shortModalOpen, setAiShortModalOpen] = useState(false);

  const [isAiShortModalActivated, setIsAiShortModalActivated] = useState(false);
  const [isAiSummaryModalActivated, setIsAiSummaryModalActivated] = useState(false);

  const [openCreateAISummaryModal, setOpenCreateAISummaryModal] = useState(false);
  const [openCreateAIShortsModal, setOpenCreateAIShortsModal] = useState(false);
  const [openRegenerateTranscriptionModal, setOpenRegenerateTranscriptionModal] = useState(false);
  const [textWithDetails, setTextWithDetails] = useState({});

  const [choppedParts, setChoppedParts] = useState([]); // stores the 30min segment chunks
  const [partIndex, setPartIndex] = useState(0);        // index of current part being processed
  const [aiSummaryUUIDState, setAiSummaryUUIDState] = useState(0);
  const [searchParams] = useSearchParams();
  const[hasTitle, setHasTitle] = useState(false)
  const[hasPart, setHasPart] = useState(false)
  const [showMoreOptions, setShowMoreOptions] = useState(false);
  
  const queryParams = {
    from: searchParams.get("from"),
    sourceLang: searchParams.get("sourceLang"),
    targetLang: searchParams.get("targetLang"),
    minDuration: searchParams.get("minDuration"),
    silence: searchParams.get("silence"),
    chapterNum: searchParams.get("chapterNum"),
  };

  const checkIsCompany = async () => {
    await GetRegistration().then((res) => {
      setIsCompany(res.data.company_confirmed);
    }) 
  }

  const checkExistingSubtitleInfo = async () => {
    if (ProjectJSON.subtitles) {
      const exsitSubtitleID = Object.keys(ProjectJSON.subtitles);
      const existSubtitleRes = await getSubtitleInfo(exsitSubtitleID[0]);
      if (existSubtitleRes.data.lang) {
        setLanguage(existSubtitleRes.data.lang)
        setSumaryTxtLang(existSubtitleRes.data.lang)
        setExistSubtitleTxt(existSubtitleRes.data.manifest.text);
      } 
    }
  };

  useEffect(() => {
    // 1. Check if videos exist to avoid errors
    const videoKeys = Object.keys(ProjectJSON?.videos || {});

    if (videoKeys.length > 0) {
      // 2. Map through the videos to find the furthest point on the timeline
      const projectDurations = videoKeys.map(videoKey => ProjectJSON.videos[videoKey].timeline_end);
      const calculatedMax = Math.max(...projectDurations);

      // 3. Update the state with the calculated max
      setMainProjectDuration(calculatedMax);
      console.log('Calculated Project Duration:', calculatedMax);
    } else {
      // Fallback if no videos are present
      setMainProjectDuration(ProjectJSON.duration || 0);
    }
  }, [ProjectJSON]); // <--- IMPORTANT: Add ProjectJSON as a dependency

  useEffect(() => {
    if (queryParams.from === "AIShorts") {
      setLanguage(queryParams.sourceLang);
      setSumaryTxtLang(queryParams.targetLang);
      setAiSummarySilence(Number(queryParams.silence));
      setAiShortsDuration(Number(queryParams.minDuration));
      setAiShortsNumber(Number(queryParams.chapterNum));
    } else {
      initSummaryUUID();
    }
  }, [])

  useEffect(() => {
    checkIsCompany()
    checkExistingSubtitleInfo()
  }, [])

  const handleShort = async () => {
    console.table({
      language,
      sumaryTxtLang,
      aiSummarySilence,
      aiShortsDuration,
      aiShortsNumber
    })
    setUploading([]);
    navigate(window.location.pathname, { replace: true });
    await initSummaryUUID();
    await createShortSubtitleStr(false);
  }

  useEffect(() => {
    const projectJSONVideos = Object.keys(ProjectJSON?.videos || {});
    const existingSubtitles= Object.keys(ProjectJSON?.subtitles || {});

    let assets = Object.assign({}, ProjectJSON.asset);
    let assetKeys = Object.keys(assets);
    setAssetUUID(assetKeys[0]);

    if (
      queryParams.from === "AIShorts" &&
      projectJSONVideos.length > 0 &&
      language &&
      sumaryTxtLang &&
      aiSummarySilence &&
      aiShortsDuration &&
      aiShortsNumber &&
      existingSubtitles.length === 0
    ) {
      handleShort();
    }
  }, [
    videoElements,
    language,
    sumaryTxtLang,
    aiSummarySilence,
    aiShortsDuration,
    aiShortsNumber
  ]);


  useEffect(() => {
    let processing = [];
    let keys = Object.keys(uploadingFiles);
    keys.forEach((key) => {
      let file = uploadingFiles[key];
      if (!file.state) processing.push(file);
    })

    setUploading(processing);
  }, [uploadingFiles])

  useEffect(() => {
    let tempData = {}
    let item = localStorage.getItem('user_data')

    if (!!item && JSON.parse(item)?.state === 'loggedin') {
      tempData = JSON.parse(item)
    }

    setUserData(tempData)
  }, [loginState])

  const languageChange = (e) => {
    let lan = e.target.value
    setLanguage(lan)
    setSumaryTxtLang(lan)
  }

  useEffect(() => {
    // Set default slider value to half of the maximum words
    if (existSubtitleWords && existSubtitleWords.length > 0) {
      setAiSummaryCount(Math.floor(existSubtitleWords.length / 2));
    }
  }, [existSubtitleWords]);

  // useEffect(() => {
    // initSummaryUUID();
    // createSubtitleStr();
    // loadSummaryUUID();
  // }, [])

  const initSummaryUUID = async () => {
    const projectJSONVideos = Object.keys(ProjectJSON.videos);
    const projectJSONAudios = Object.keys(ProjectJSON.audios);
    const projectJSONImages = Object.keys(ProjectJSON.images);
    if(projectJSONVideos.length != 1 || projectJSONAudios.length != 0 || projectJSONImages.length != 0) {
      Swal.fire({
        title: "Warning",
        text: "AI Summary is only available for 'single video projects'. You cannot generate AI Summary & Reels.",
        icon: "warning"
      });
    }

    dispatch(stageText_Store('Loading AI Summary Menu ...'))
    dispatch(isAnalyzing_Store(true));
    const exsitSubtitleID = Object.keys(ProjectJSON?.subtitles || {});
    if(exsitSubtitleID.length > 0){
      setSubtitleUUID(exsitSubtitleID[0]);
      const existSubtitleRes = await getSubtitleInfo(exsitSubtitleID[0]);

      if (existSubtitleRes.data.manifest.words) {
        setExistSubtitleWords(existSubtitleRes.data.manifest.words);
        setExistSubtitleTxt(existSubtitleRes.data.manifest.text);
        if (existSubtitleRes.data.manifest) {
          setAiSummaryCount(existSubtitleRes.data.manifest.words.length); // Set slider max value based on count
        }
      } else {
        setExistSubtitleTxt("Transcript is not available for the project");
      }
    }

    const projectDurations = Object.keys(ProjectJSON.videos).map(videoKey => ProjectJSON.videos[videoKey].timeline_end);
    const totalProjectDuration = Math.max(...projectDurations);

    setProjectMaxDuration(totalProjectDuration / 1000.0);
    setAiSummaryDuration(totalProjectDuration / 1000.0 / 2);

    setAiSummarySilence(0.5);

    dispatch(isAnalyzing_Store(false));
  }

  const handleInputChange = (event) => {
    const value = event.target.value.split('/')[0]; // Extracting the current count
    setAiSummaryCount(Number(value));
  };

  const handleDurationSliderChange = (event, newValue) => {
    setAiSummaryDuration(newValue);
    const newCountValue = (newValue / projectMaxDuration) * existSubtitleWords.length;
    setAiSummaryCount(newCountValue.toFixed(0));
  };

  const handleSilenceDetectionSliderChange = (event, newValue) => {
    setAiSummarySilence(newValue);
  };

  const handleShortsDurationSliderChange = (event, newValue) => {
    setAiShortsDuration(newValue);
  };
  const handleShortsNumberSliderChange = (event, newValue) => {
    setAiShortsNumber(newValue);
  };

  const [showPricingPageModal, setShowPricingPageModal] = useState(false);
  const handleClosePricingModal = () => {
    setShowPricingPageModal(false)
  }

  const isSingleVideoProject = () => {
    const projectJSONVideos = Object.keys(ProjectJSON.videos);
    const projectJSONAudios = Object.keys(ProjectJSON.audios);
    const projectJSONImages = Object.keys(ProjectJSON.images);
    if(projectJSONVideos.length != 1 || projectJSONAudios.length != 0 || projectJSONImages.length != 0) {
      Swal.fire({
        title: "Warning",
        text: "AI Summary is only available for 'single video projects'. You can cannot generate AI Summary & Reels.",
        icon: "error"
      });
      return false;
    }
    return true;
  }

  const createSubtitleStr =async (forceGenerateSubtitles) => {
    handleCloseCreateAISummaryModal()
    // if (!isCompany) {
    // setShowPricingPageModal(true);
    //   return;
    // }
    
    if (isSingleVideoProject() == false) return;
    setIsSummary(true);
    if(!userData || userData.subtitle_state == false){
      setShowPricingPageModal(true)
    }else{
      if(uploading.length > 0 || subcreating){
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "There is an ongoing upload or an AI auto subtitles in progress, please wait for the completion.",
          showConfirmButton: true,
          confirmButtonText: "Ok",
        }).then((result) => {
          if (result.isConfirmed) {
            return;
          } else {
            return;
          }
        });
      }else{
        dispatch(isAnalyzing_Store(true));
        dispatch(stageText_Store('Analysing Transcript ...'))
        loadSummaryUUID(forceGenerateSubtitles, true);
      }
    }
  }
  const {onClickExportBtn} = useExport();

  const handleDirectAIShortExport = async () => {
    let directAiShortsText = "";
    if (!existSubtitleTxt) await regenerateTranscript();
      const exsitSubtitleID = Object.keys(ProjectJSON.subtitles);
    if(exsitSubtitleID.length > 0){
      setSubtitleUUID(exsitSubtitleID[0]);
      const existSubtitleRes = await getSubtitleInfo(exsitSubtitleID[0]);

      if (existSubtitleRes.data.manifest.words) {
        setExistSubtitleWords(existSubtitleRes.data.manifest.words);
        setExistSubtitleTxt(existSubtitleRes.data.manifest.text);
        directAiShortsText = existSubtitleTxt;
        if (existSubtitleRes.data.manifest) {
          setAiSummaryCount(existSubtitleRes.data.manifest.words.length);
        }
      } else {
        setExistSubtitleTxt("Transcript is not available for the project");
      }
    }
    // onClickExportBtn(false,true);
    const countWords = (str) => {
      const words = str.trim().split(/\s+/).filter(Boolean);
      return words.length;
    }

    const formattedDuration = ProjectJSON.duration / 1000;
    
    const textLength = countWords(directAiShortsText);

    const directAiShortsModalData = {
      "chapters": {
        "0": {
          "new_transcript": directAiShortsText,
          "new_timestamps": [
            `0.0-${formattedDuration}`
          ],
          "confidence": 0,
          "topic": "",
          "comment": "",
          "importance": 0.09,
          "word_order": `0 ${textLength}`,
        },
      }
    }
    setModalData(directAiShortsModalData);
    setIsDirectAIShort(true);
    setAiShortModalOpen(true);
  }

  function titleCase(str) {
   var splitStr = str.toLowerCase().split(' ');
   for (var i = 0; i < splitStr.length; i++) {
       splitStr[i] = splitStr[i].charAt(0).toLocaleUpperCase(language) + splitStr[i].substring(1);     
   }
   return splitStr.join(' '); 
}

  function generateChaptersFromContextualData(contextualData) {
  if (!contextualData?.words_and_timestamps) return { chapters: {} };

  const lines = contextualData.words_and_timestamps.trim().split('\n');

  const wordObjects = lines.map(line => {
    const [wordIndexAndWord, time] = line.split('-');
    const [wordRaw, index] = wordIndexAndWord.trim().split('(');
    const word = wordRaw.trim();
    const [startTime, endTime] = time.split(':').map(Number);

    return {
      word,
      index: parseInt(index?.replace(')', '')),
      startTime,
      endTime,
    };
  });

  const chapters = {};
  let currentChapterWords = [];
  let currentChapterStart = null;
  let currentChapterEnd = null;
  let chapterIndex = 0;
  let wordOrderStart = null;

  const isSentenceEnd = (word) =>
    /[.!?]$/.test(word) && !/\.\.\.$/.test(word);

  for (let i = 0; i < wordObjects.length; i++) {
    const wordObj = wordObjects[i];

    if (currentChapterWords.length === 0) {
      currentChapterStart = wordObj.startTime;
      wordOrderStart = wordObj.index;
    }

    currentChapterWords.push(wordObj.word);
    currentChapterEnd = wordObj.endTime;

    if (isSentenceEnd(wordObj.word) || i === wordObjects.length - 1) {
      const newTranscript = currentChapterWords.join(' ');
      const topic = currentChapterWords.slice(0, 3).join(' ');

      chapters[chapterIndex] = {
        new_transcript: newTranscript,
        new_timestamps: [`${currentChapterStart.toFixed(3)}-${currentChapterEnd.toFixed(3)}`],
        confidence: 0,
        topic: titleCase(topic),
        comment: null,
        importance: Math.random().toFixed(2), // 0 to 1
        word_order: `${wordOrderStart} ${wordObj.index}`,
      };

      // Reset
      currentChapterWords = [];
      currentChapterStart = null;
      currentChapterEnd = null;
      wordOrderStart = null;
      chapterIndex++;
    }
  }

  return { chapters };
}

  const createShortSubtitleStr = async (forceGenerateSubtitles) => {
    handleCloseCreateAIShortsModal()
    if (isSingleVideoProject() == false) return;
    setIsSummary(false)
    if(!userData || userData.subtitle_state == false){
      setShowPricingPageModal(true)
    }else{
      if(uploading.length > 0 || subcreating){
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "There is an ongoing upload or an AI auto subtitles in progress, please wait for the completion.",
          showConfirmButton: true,
          confirmButtonText: "Ok",
        }).then((result) => {
          if (result.isConfirmed) {
            return;
          } else {
            return;
          }
        });
      }else{
        // if (ProjectJSON.duration < 60000) {
        //   handleDirectAIShortExport();
        //   return;
        // }
        dispatch(isAnalyzing_Store(true));
        dispatch(stageText_Store('Analysing Transcript ...'))
        loadSummaryUUID(forceGenerateSubtitles, false);
      }
    }
  }

const waitSubtitle = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const regenerateTranscript = async () => {
  handleCloseRegenerateTranscriptionModal();

  let assets = Object.assign({}, ProjectJSON.asset);
  let assetKeys = Object.keys(assets);
  if (!projectUUID || assetKeys.length === 0 || !language) return;
  if (!isSingleVideoProject()) return;

  if (uploading.length > 0 || subcreating) {
    Swal.fire({
      position: "center",
      icon: "warning",
      title: "There is an ongoing upload or an AI auto subtitles in progress, please wait for the completion.",
      showConfirmButton: true,
      confirmButtonText: "Ok",
    });
    return;
  }

  dispatch(isAnalyzing_Store(true));
  dispatch(stageText_Store("Analysing Transcript ..."));
  setExistSubtitleTxt("");

  const resData = await createSubtitle(projectUUID, assetKeys[0], language);
  if (resData.state !== "success") {
    Swal.fire({
      title: "Transcript Creation Failed",
      text: "Subtitle creation has failed.",
      icon: "error",
    });
    dispatch(isAnalyzing_Store(false));
    return;
  }

  const newSubtitleUUID = resData.data.uuid;
  setSubtitleUUID(newSubtitleUUID);

  const videoDurationMin = Math.ceil(resData.duration || 1); 
  const maxAttempts = Math.min(videoDurationMin * 60, 1200); 

  let subtitleInfo = null;
  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    await waitSubtitle(1000); 
    const response = await getSubtitleInfo(newSubtitleUUID);
    if (response.data?.state === 2) {
      subtitleInfo = response;
      break;
    }
  }

  if (subtitleInfo && subtitleInfo.data.manifest?.words?.length > 0) {
    const manifest = subtitleInfo.data.manifest;
    setExistSubtitleWords(manifest.words);
    setExistSubtitleTxt(manifest.text);
    setAiSummaryCount(manifest.words.length);
  } else {
    setExistSubtitleTxt("Transcript is not available for the project");
  }

  dispatch(isAnalyzing_Store(false));
};



  const loadSummaryUUID = async (forceGenerateSubtitles, forSummary) => {
    let assets = Object.assign({}, ProjectJSON.asset)
    let assetKeys = Object.keys(assets)

    let category = "AI_STANDART"

    if (aiSilence == true) category = "AI_SILENCE_REMOVER"
    else category = "AI_SUMMARY"

    const responseData = await createChatGPTSummary(category);
    if(responseData.state != 'success'){
      // window.toastr.error(responseData.data);
      Swal.fire({
        title: "AI Summary has failed",
        text: "AI Summary has failed for creating AI Summary",
        icon: "error"
      });
      dispatch(isAnalyzing_Store(false));
      return;
    }
    const aiSummaryUUID = responseData.data.uuid;
    setSummaryUUID(aiSummaryUUID)
    if(!subtitleUUID || forceGenerateSubtitles == true){
      setExistSubtitleTxt("");
      let resData = await createSubtitle(projectUUID, assetKeys[0], language);
      if(resData.state != 'success'){
        // window.toastr.error(resData.data);
        Swal.fire({
          title: "AI Summary has failed",
          text: "AI Summary has failed for creating Transcript",
          icon: "error"
        });
        dispatch(isAnalyzing_Store(false));
        return;
      }
      setSubtitleUUID(resData.data.uuid);
      setTimeout(function (){
        createAISummary(resData.data.uuid, aiSummaryUUID, forSummary);
      }, 1000)
    } else {
      setAiSummaryUUIDState(aiSummaryUUID)
      existAISummary(subtitleUUID, aiSummaryUUID, forSummary);
    }
  }

  const existAISummary = async (subtitleID, aiSummaryUUID, forSummary) => {
    
    // const responseData = await createChatGPTSummary();
    // const aiSummaryUUID = responseData.data.uuid;
    // setSummaryUUID(responseData.data.uuid)
    
    let assets = Object.assign({}, ProjectJSON.asset);
    let assetKeys = Object.keys(assets);
    const selectedAsset = assets[assetKeys[0]]
    const videos = ProjectJSON.videos
    
    const videoKeys = Object.keys(videos);
    let videoItem = videos[videoKeys[0]];
    let videoEleItem = videoElements[videoKeys[0]];
    setShowVideoPath(videoEleItem.src);
    // const existSubtitleRes = await getSubtitleInfo(subtitleID)
    // if(existSubtitleRes.state != 'success') return;
    // console.log('loading Subtitle Res', existSubtitleRes);
    let contextualData;
    
    if (aiSilence) {
      contextualData = parseSentences(existSubtitleWords)
      setTextWithDetails(contextualData);
      modalConfirmSumary(contextualData, videoItem, selectedAsset, videoEleItem);
      return;
    } else { 
      contextualData = parseWords(existSubtitleWords);
    }
    dispatch(stageText_Store('Creating AI summary ...'))

    // console.log("----Logs Start----")
    // console.log("contextualData:", contextualData);
    
    let gptSumaryData = { data: { state_text: 'PENDING' } };
    let fallbackChapters = null;
    if ((OpenAIEnabled_AIShort == true && forSummary == false) || (forSummary == true)) {
      gptSumaryData = await submitChatGPTSummary(aiSummaryUUID, sumaryTxt, contextualData, aiSummaryCount, aiSummarySilence);
      //console.log("Submitted gptSumaryData:", gptSumaryData);

      const MAX_WAIT_TIME_MS = 5 * 60 * 1000; // 5 minutes
      const startTime = Date.now();

      while (gptSumaryData.data.state_text != 'SUCCESS') {
        // To enable OpenAI GPT Summary, uncomment the following line and comment the line after it.
        gptSumaryData = await getChatGPTSummary(aiSummaryUUID, sumaryTxt, contextualData);

        if (gptSumaryData.data.state_text === 'SUCCESS') {
          break;
        }

        const hasFailed = gptSumaryData.data.state_text === 'FAILED' || gptSumaryData.data.state_text === undefined;
        const hasTimedOut = Date.now() - startTime > MAX_WAIT_TIME_MS;

        if (hasFailed || hasTimedOut) {
          fallbackChapters = generateChaptersFromContextualData(contextualData);
          if (!fallbackChapters) {
            Swal.fire({
              title: "AI Summary has failed, Please try again",
              text: `Reason code: ${gptSumaryData.data.Code || "Error"}`,
              icon: "error"
            });
            dispatch(isAnalyzing_Store(false));
            return;
          }
          break;
        }

        await new Promise(r => setTimeout(r, 3000)); // wait 3 second before retrying
      }
    } else {
      fallbackChapters = generateChaptersFromContextualData(contextualData);
      if (!fallbackChapters) {
        Swal.fire({
          title: "AI Summary has failed, Please try again",
          text: `Reason code: ${gptSumaryData.data.Code || "Error"}`,
          icon: "error"
        });
        dispatch(isAnalyzing_Store(false));
        return;
      }
    }
    // console.log("Get gptSumaryData:", gptSumaryData);
    // console.log("fallbackChapters:", fallbackChapters);
    
    const gptSumaryObj = fallbackChapters ? fallbackChapters : JSON.parse(gptSumaryData.data.response);
    // console.log("gptSumaryObj:", gptSumaryObj);
    // console.log("----Logs End----")
    if (!gptSumaryObj || Object.keys(gptSumaryObj).length === 0) {
      Swal.fire({
        title: "AI Summary has failed",
        text: gptSumaryData.data.reason,
        icon: "error"
      });
      dispatch(isAnalyzing_Store(false));
      return;
    }

    // const modalSummaryData = JSON.parse(gptSumaryData.data.metadata.summary)
    // console.log(modalSummaryData);
    // let modalArr = [];
    // const sumKeys = Object.keys(gptSumaryObj);

    // sumKeys.map(kItem => {
    //   gptSumaryObj[kItem].userDirect = kItem;
    //   modalArr.push(gptSumaryObj[kItem]);
    // })
    dispatch(isAnalyzing_Store(false));
    setModalData(gptSumaryObj);
    setSummaryData(gptSumaryData);
    if(forSummary){
      setModalOpen(true);
      setIsAISummary(true);
    }else if (contextualData.words_and_timestamps){
      setTextWithDetails(contextualData);
      setAiShortModalOpen(true);
      setIsAIShort(true);
    }
}

  const silenceBuffer = 100;

  const modalConfirmSumary = async (gptSumaryObj, videoItem, selectedAsset, videoEleItem) =>{
    let newTimestamps = {};
    let newJSONData = Object.assign({}, ProjectJSON);
    let initStartTime = 0
    let updatedVideoElements = {};

    gptSumaryObj.new_timestamps.map((stampItem, index, array) => {
      const startTime = parseFloat(stampItem.split('-')[0]) * 1000;
      const endTime = parseFloat(stampItem.split('-')[1]) * 1000;
      const newItemId = uuidv4();
      const newVideoItem = Object.assign({}, videoItem);
      newVideoItem.segment_start  = startTime - newVideoItem.timeline_start - silenceBuffer > 0 ? startTime - newVideoItem.timeline_start - silenceBuffer : 0;
      newVideoItem.segment_end    = endTime - newVideoItem.timeline_start + silenceBuffer + silenceBuffer + silenceBuffer;
      newVideoItem.duration       = newVideoItem.segment_end - newVideoItem.segment_start;
      newVideoItem.timeline_start = initStartTime;
      newVideoItem.timeline_end   = newVideoItem.timeline_start + newVideoItem.duration;
      newVideoItem.signed_url = selectedAsset.signed_url;

      newVideoItem.coordinate.x = videoItem.coordinate.x;
      newVideoItem.coordinate.y = videoItem.coordinate.y;
      newVideoItem.dimension = videoItem.dimension;
      newVideoItem.ratioWH = videoItem.ratioWH;

      initStartTime = newVideoItem.timeline_end;
      const newVideoEle = videoEleItem.cloneNode(true);
      newVideoEle.id = newItemId;

      updatedVideoElements = { ...updatedVideoElements, [newItemId]: newVideoEle };
      
      newTimestamps = {...newTimestamps, [newItemId]: newVideoItem};
    })
    newJSONData['videos'] = newTimestamps;

    let markers = [];
    let responseJson = JSON.parse(summaryData.data.response);
    let markerStartTime = 0;
    let chapters = responseJson.chapters;

    for (let chapterKey in chapters) {
      if (chapters.hasOwnProperty(chapterKey)) {
        let chapter = chapters[chapterKey];
        const newMarkerId = uuidv4();
        const startTime = parseFloat(chapter.new_timestamps[0].split('-')[0]) * 1000;
        const endTime = parseFloat(chapter.new_timestamps[0].split('-')[1]) * 1000;

        // Check if the chapter's timestamp is included in gptSumaryObj
        const isChapterIncluded = gptSumaryObj.new_timestamps.some(stamp => {
          const [sumStartTime, sumEndTime] = stamp.split('-').map(time => parseFloat(time) * 1000);
          return startTime === sumStartTime && endTime === sumEndTime;
        });

        if (isChapterIncluded) {
          const newMarkerContext = {
            id: newMarkerId,
            timeline_start : markerStartTime,
            timeline_end   : markerStartTime + (endTime - startTime),
            original_start : startTime,
            original_end   : endTime,
            duration       : endTime - startTime,
            topic          : chapter.topic,
            comment        : chapter.comment,
            confidence     : chapter.confidence,
            importance     : chapter.importance,
            transcript     : chapter.new_transcript,
            color          : "#ff0000"
          }
          markerStartTime = newMarkerContext.timeline_end;
          markers = [...markers, newMarkerContext];
        }
      }
    }
    let sortedMarkers = markers.sort((a, b) => { return a.timeline_start - b.timeline_start; });
    newJSONData.markers = sortedMarkers;

    dispatch(stageText_Store('Opening new AI Summary Project ...'))
    const totalTime = await getTotalProjectTime(newJSONData);
    newJSONData.duration = totalTime;

    newJSONData.title = 'AISummary-(' + Math.round(totalTime / 1000) + "secs)-" + newJSONData.title;

    const newProjectType = 2; // AI_SUMMARY;
    const result = await duplicatePrjoectJSON(projectUUID, newJSONData, newProjectType);
      if (result.state !== 'success') {
        // return window.toastr.error(result.data.message)
        Swal.fire({
          title: "AI Summary has failed",
          text: "AI Summary has failed",
          icon: "error"
        });
        return;
      }
      const data = result.data
      const duplicateUUID = data['Duplicated Project uuid']
      //window.location.href = `/edit/${duplicateUUID}/`
      dispatch(isAnalyzing_Store(false));
      const popup = window.open(`/edit/${duplicateUUID}/`, '_blank');
      if (popup === null || typeof popup === 'undefined') {
        Swal.fire({
          title: "Please enable Popups",
          text: "Please allow popups for Kedy.ai, so AI Summary project can be opened in a new tab.",
          icon: "warning"
        });
      }
  }

  const onAiShortCancel = () => {
    const videos = document.querySelectorAll(".ai-short-export-video");
    if (videos) {
      videos.forEach(video => {
        if (!video.paused && !video.ended) {
          video.pause();
        }
      })
    }
    setAiShortModalOpen(false) ;
  }

  

  const onModalCancel = () => {
    setModalOpen(false);
    setModalData([]);
    dispatch(isAnalyzing_Store(false));
  }

  const onModalConfirm = (selectedModal) => {
    //setModalOpen(false);
    setModalData([]);
    dispatch(isAnalyzing_Store(true));
    let assets = Object.assign({}, ProjectJSON.asset);
    let assetKeys = Object.keys(assets);
    const selectedAsset = assets[assetKeys[0]]
    const videos = ProjectJSON.videos
    const videoKeys = Object.keys(videos);
    let videoItem = videos[videoKeys[0]];
    let videoEleItem = videoElements[videoKeys[0]];
    modalConfirmSumary(selectedModal, videoItem, selectedAsset, videoEleItem)
  }

  const createAISummary = async (subtitleID, aiSummaryUUID, forSummary) => {
    
    const JSONdata = await getProjectJSON(projectUUID);

    const projectData = JSONdata?.data[projectUUID];
    if (!projectData) {
      // changeCreating(false);
      
      return;
    }
    let assets = Object.assign({}, projectData.asset);
    let assetKeys = Object.keys(assets);
    const selectedAsset = assets[assetKeys[0]]
    const videos = projectData.videos
    
    const videoKeys = Object.keys(videos);
    let videoItem = videos[videoKeys[0]];
    let videoEleItem = videoElements[videoKeys[0]];
    videoKeys.map(vIndex => {
      if(videos[vIndex].asset_uuid == assetKeys[0]){
        videoItem = Object.assign({}, videos[vIndex]);
        videoEleItem = videoElements[vIndex];
      }
    })
    setShowVideoPath(videoEleItem.src);
    let newSubtitle = Object.assign({}, projectData.subtitles);
    let newSubKeys = Object.keys(newSubtitle);
    let subKey = newSubKeys.find((key) => newSubtitle[key].state !== 3);
    let subState = newSubtitle[subKey].state;
    if (subState !== 2 && subState !== 3) {
      setTimeout(() => {
        createAISummary(subtitleID, aiSummaryUUID, forSummary);
      }, 3000);

      return;
    }
    let webhookRes = await subtitleWebHookPoll(projectUUID, assetKeys[0], subtitleID, 2);
    let webhookData = webhookRes.data;

    if (webhookData.manifest.words == undefined) {
      setExistSubtitleTxt("Transcript is not available for the project");
      dispatch(isAnalyzing_Store(false));

      Swal.fire({
        title: "Transcription is not detected for this language selection.",
        text: `Reason code: ${aiSummaryUUID}`,
        icon: "warning"
      });

      return;
    }

    setSubTitlesData(webhookData.manifest);
    setExistSubtitleWords(webhookData.manifest.words);
    setExistSubtitleTxt(webhookData.manifest.text);

    let contextualData;
    
    if (aiSilence) {
      contextualData = parseSentences(webhookData.manifest.words)
      modalConfirmSumary(contextualData, videoItem, selectedAsset, videoEleItem);
      return;
    } else {
      contextualData = parseWords(webhookData.manifest.words);
    }
    dispatch(stageText_Store('Creating AI summary ...'))

    // console.log("----Logs Start----")
    // console.log("contextualData:", contextualData);

    let gptSumaryData = { data: { state_text: 'PENDING' } };
    let fallbackChapters = null;
    if ((OpenAIEnabled_AIShort == true && forSummary == false) || (forSummary == true)) {
      gptSumaryData = await submitChatGPTSummary(aiSummaryUUID, sumaryTxt, contextualData, aiSummaryCount, aiSummarySilence);

      const MAX_WAIT_TIME_MS = 5 * 60 * 1000; // 5 minutes
      const startTime = Date.now();

      while (gptSumaryData.data.state_text !== 'SUCCESS') {
        // To enable OpenAI GPT Summary, uncomment the following line and comment the line after it.
        gptSumaryData = await getChatGPTSummary(aiSummaryUUID, sumaryTxt, contextualData);

        if (gptSumaryData.data.state_text === 'SUCCESS') {
          break;
        }

        const hasFailed = gptSumaryData.data.state_text === 'FAILED' || gptSumaryData.data.state_text === undefined;
        const hasTimedOut = Date.now() - startTime > MAX_WAIT_TIME_MS;

        if (hasFailed || hasTimedOut) {
          fallbackChapters = generateChaptersFromContextualData(contextualData);
          if (!fallbackChapters) {
            Swal.fire({
              title: "AI Summary has failed, Please try again",
              text: `Reason code: ${gptSumaryData.data.Code || "Error"}`,
              icon: "error"
            });
            dispatch(isAnalyzing_Store(false));
            return;
          }
          break;
        }

        await new Promise(r => setTimeout(r, 3000)); // wait 3 second before retrying
      }
    } else {
      fallbackChapters = generateChaptersFromContextualData(contextualData);
      if (!fallbackChapters) {
        Swal.fire({
          title: "AI Summary has failed, Please try again",
          text: `Reason code: ${gptSumaryData.data.Code || "Error"}`,
          icon: "error"
        });
        dispatch(isAnalyzing_Store(false));
        return;
      }
    }

    // console.log("Get gptSumaryData:", gptSumaryData);
    // console.log("fallbackChapters:", fallbackChapters);

    const gptSumaryObj = fallbackChapters ? fallbackChapters : JSON.parse(gptSumaryData.data.response);

    // console.log("gptSumaryObj:", gptSumaryObj);
    // console.log("----Logs End----")

    if (!gptSumaryObj || Object.keys(gptSumaryObj).length === 0) {
      Swal.fire({
        title: "AI Summary has failed",
        text: gptSumaryData.data.reason,
        icon: "error"
      });
      dispatch(isAnalyzing_Store(false));
      return;
    }
    dispatch(isAnalyzing_Store(false));
    setModalData(gptSumaryObj);
    setSummaryData(gptSumaryData);
    if(forSummary){
      setModalOpen(true);
      setIsAISummary(true);
    }else{
      setTextWithDetails(contextualData);
      setAiShortModalOpen(true);
      setIsAIShort(true);
    }
   
  }
  const parseSentences = (words) => {
    // Sort words array by 'start' timestamp
    words.sort((a, b) => a.start - b.start);
  
    let transcript = '';
    let timeArr = [];
    let words_and_timestamps = '';
  
    let count = 0;
    let sentence_start = null;
    let previous_end = null;
  
    words.forEach((word) => {
      transcript += `${word.text} `;
      words_and_timestamps += `${word.text}(${count})-${word.start / 1000}:${word.end / 1000}\n`;
      count++;

      if (sentence_start === null) sentence_start = word.start;

      if (previous_end !== null && word.start - previous_end > 100) {
        timeArr.push(`${sentence_start / 1000}-${previous_end / 1000}`);
        sentence_start = word.start;
      }
  
      previous_end = word.end;
    });

    if ((sentence_start !== null) && (previous_end !== null)){
      timeArr.push(`${sentence_start / 1000}-${previous_end / 1000}`);
    }
  
    return {
      transcript: transcript.trim(),
      new_timestamps: timeArr,
      words_and_timestamps: words_and_timestamps.trim()
    };
  };

  const parseWords = (words) => {
    words.sort((a,b) => { return a.end - b.start });
    let texts = '';
    let timeArr = [];
    let words_and_timestamps = '';

    let count = 0;
    words.forEach((wItem) => {
      texts = `${texts} ${wItem.text}`;
      timeArr.push(`${(wItem.start / 1000)}-${wItem.end / 1000}`)
      words_and_timestamps = `${words_and_timestamps} ${wItem.text}(${count})-${wItem.start / 1000}:${wItem.end / 1000}\n`;
      count++;
    });
    return {
      transcript: texts,
      timestamps: timeArr,
      words_and_timestamps: words_and_timestamps
    }
  }

  const handleCloseCreateAISummaryModal = () => {
    setOpenCreateAISummaryModal(false);
  }

  const handleCloseCreateAIShortsModal = () => {
    setOpenCreateAIShortsModal(false);
  }

  const handleCloseRegenerateTranscriptionModal = () => {
    setOpenRegenerateTranscriptionModal(false);
  }

  useEffect(()=> {
    if(language){
      setLanguageKey(language);
    }
  }, [language])

  const isTooLong = mainprojectDuration > 60000 * 5;
  const durationInMinutes = (mainprojectDuration / 60000).toFixed(1);

  return (
    <>
    <Box md={12} className='px-10 pt-0'>

      <Typography className="v-block-footer my-6">{languageStrs.subtitles_allowance_remaining} : {userData?.subtitle_remaining}</Typography>

      <Button
        className="mt-4"
        variant="contained"
        fullWidth
        size='large'
        endIcon={<AutoFixHighIcon />}
        onClick={() => { 
          if(isSummary) {
            setModalOpen(true);
          } else {
            //createSubtitleStr(false)
            setOpenCreateAISummaryModal(true)
          }
         }}
      >
        {isAISummary ? "Show" : "Create"} AI Summary
      </Button>

      <Button
        className="mt-12"
        variant="contained"
        fullWidth
        size='large'
        endIcon={<AppShortcutIcon />}
        onClick={() => {
          if(isAIShort) {
            setAiShortModalOpen(true);
          } else {
            //createShortSubtitleStr(false) 
            setOpenCreateAIShortsModal(true)
          }
        }}
      >
         {isAIShort ? "Show" : "Create"} AI Short
      </Button>

      {existSubtitleTxt &&
        <Button
          className="my-12"
          variant="outlined"
          fullWidth
          size='medium'
          endIcon={<TextSnippetIcon />}
          // onClick={regenerateTranscript}
          onClick={() => setOpenRegenerateTranscriptionModal(true)}
        >
          Regenerate Transcript
        </Button>
      }

      {/* <FormControlLabel
        control={
          <Checkbox checked={aiSilence} onChange={() => {setAiSilence(!aiSilence)}} />
        }
        label="AI Silence Remover"
      /> */}
{/* 
      <Box className='p-2'>
        <Box className='v-autocomplate pt-2'>
            <InputLabel id='select-language-detect'>{languageStrs.select_language_detect}</InputLabel>
            <Select
              value={language}
              inputProps={{ 'aria-label': 'Without label' }}
              className='v-hoverborder v-radius v-commonboxheight'
              onChange={languageChange}
              labelId='select-language-detect'
            >
              {languageToList1.map((option, key) =>
                <MenuItem value={option.key} key={key}>
                  <Typography component='span'
                  >{option.label}</Typography>
                </MenuItem>
              )}
            </Select>
        </Box>
      </Box> */}

      {/* <Box className='p-2'>
        <Box className='v-autocomplate pt-4'>
            <InputLabel id='summarize-content'>Summarize your content in</InputLabel>
            <Select
              value={sumaryTxtLang}
              inputProps={{ 'aria-label': 'Without label' }}
              className='v-hoverborder v-radius v-commonboxheight'
              onChange={({target}) => {
                const langKey = target.value;
                const langLabel = languageToList1.find(lang => lang.key === langKey)?.label;
                setSumaryTxtLang(langKey);
                setSumaryTxt(`Provide titles and comments in ${langLabel}`);
              }}
              labelId='summarize-content'
            >
              {languageToList1.map((option, key) =>
                <MenuItem value={option.key} key={key}>
                  <Typography component='span'
                  >{option.label}</Typography>
                </MenuItem>
              )}
            </Select>
        </Box>
      </Box> */}

      {/* <Typography className="v-block-footer mb-2">How do you want to summarize your content</Typography>
      <Box className="v-hoverborder v-radius">
        <Box className="v-inputbox px-10 py-5">
          <textarea 
            rows={3}
            value={sumaryTxt}
            className="default-input w-full"
            placeholder="For example : Provide titles and comments in English ..."
            onChange={({target}) => {
              setSumaryTxt(target.value);
            }}
          />
        </Box>
      </Box> */}

      {/* <Box 
        border={1} // Adds a border around the box
        borderRadius={4} // Optional: adds rounded corners to the border
        borderColor="grey.400" // Sets the color of the border
        padding={2} // Adds some padding inside the box
        marginTop={2}
      >
        <Typography className="v-block-footer mb-2">Select the duration for your AI Summary (in secs)</Typography>
        <Box display="flex" alignItems="center" paddingY={2}>
          <Slider
            value={aiSummaryDuration.toFixed(2)}
            min={0}
            max={projectMaxDuration} // Assuming count is based on words array
            onChange={handleDurationSliderChange}
            variant="standard" // Use "standard" to minimize the border appearance
            valueLabelDisplay="auto"
            style={{ flex: 1 }}
          />
          <TextField
            value={`${aiSummaryDuration.toFixed(2)}/${projectMaxDuration.toFixed(2)}`}
            onChange={handleInputChange}
            variant="outlined"
            label="Duration(secs)"
            size="small"
            style={{ width: 100, marginLeft: 16 }}
            inputProps={{
              readOnly: true,
              style: {
                textAlign: 'center', // Center the text horizontally
                fontSize: '0.875rem', // Set the font size
                padding: 0, // Remove any padding from the input
                height: '1.0rem', // Ensure a consistent height for the input
                display: 'flex', // Use flexbox for alignment
                alignItems: 'center', // Vertically center the text
                justifyContent: 'center', // Horizontally center the text
                lineHeight: '1.0rem', // Ensure the line height matches the height
                border: 'none', // Remove the border
              },
            }}
            InputProps={{
              style: {
                height: '2.0rem', // Match the height to the input for consistency
                padding: 0, // Remove extra padding
                display: 'flex', // Flexbox for alignment
                alignItems: 'center', // Vertically center the content
                border: 'none', // Remove the border
              },
            }}
          />
        </Box>
        <Typography className="v-block-footer mb-2">Select the silence detection for your AI Summary (in secs)</Typography>
        <Box display="flex" alignItems="center" paddingY={2}>
          <Slider
            value={aiSummarySilence.toFixed(2)}
            min={0.5}
            max={10}
            step={0.1}
            onChange={handleSilenceDetectionSliderChange}
            variant="standard" // Use "standard" to minimize the border appearance
            valueLabelDisplay="auto"
            style={{ flex: 1 }}
          />
          <TextField
            value={`${aiSummarySilence.toFixed(2)}`}
            onChange={handleInputChange}
            variant="outlined"
            label="Silence(secs)"
            size="small"
            style={{ width: 100, marginLeft: 16 }}
            inputProps={{
              readOnly: true,
              style: {
                textAlign: 'center', // Center the text horizontally
                fontSize: '0.875rem', // Set the font size
                padding: 0, // Remove any padding from the input
                height: '1.0rem', // Ensure a consistent height for the input
                display: 'flex', // Use flexbox for alignment
                alignItems: 'center', // Vertically center the text
                justifyContent: 'center', // Horizontally center the text
                lineHeight: '1.0rem', // Ensure the line height matches the height
                border: 'none', // Remove the border
              },
            }}
            InputProps={{
              style: {
                height: '2.0rem', // Match the height to the input for consistency
                padding: 0, // Remove extra padding
                display: 'flex', // Flexbox for alignment
                alignItems: 'center', // Vertically center the content
                border: 'none', // Remove the border
              },
            }}
          />
        </Box>
      </Box> */}
      {existSubtitleTxt &&

        <Box className='mt-4 border rounded p-6' >
          {existSubtitleTxt}
        </Box>
      }

    </Box>

      {/* Create AI Summary Modal Start */}
      <Modal
        open={openCreateAISummaryModal}
        onClose={handleCloseCreateAISummaryModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          border: '2px solid #000',
          borderRadius: 4,
          boxShadow: 24,
          p: { xs: 2, sm: 3, md: 4 }, // responsive padding
          width: { xs: '90%', sm: 500, md: 600 } // responsive width
        }}>
          <Typography variant='h4' align='center' gutterBottom>Select AI Summary Options</Typography>

          <Box className='p-2'>
            <Box className='v-autocomplate pt-2'>
              <FormControl>
                <InputLabel id='select-language-detect'>{languageStrs.select_language_detect}</InputLabel>

                <Select
                  value={language}
                  //inputProps={{ 'aria-label': 'Without label' }}
                  //className='v-hoverborder v-radius v-commonboxheight'
                  onChange={languageChange}
                  labelId='select-language-detect'
                >
                  {languageToList1.map((option, key) =>
                    <MenuItem value={option.key} key={key}>
                      <Typography
                        component='span'
                      >
                        {option.label}
                      </Typography>
                    </MenuItem>
                  )}
                </Select>
              </FormControl>
            </Box>
          </Box>

          <Box className='p-2'>
            <Box className='v-autocomplate pt-4'>
              <FormControl>
                <InputLabel id='summarize-content'>Summarize your content in . . .</InputLabel>
                
                <Select
                  value={sumaryTxtLang}
                  // inputProps={{ 'aria-label': 'Without label' }}
                  // className='v-hoverborder v-radius v-commonboxheight'
                  onChange={({ target }) => {
                    const langKey = target.value;
                    const langLabel = languageToList1.find(lang => lang.key === langKey)?.label;
                    setSumaryTxtLang(langLabel);
                    setSumaryTxt(`Provide titles and comments in ${langLabel}`);
                  }}
                  labelId='summarize-content'
                >
                  {languageToList1.map((option, key) =>
                    <MenuItem value={option.key} key={key}>
                      <Typography
                        component='span'
                      >
                        {option.label}
                      </Typography>
                    </MenuItem>
                  )}
                </Select>
              </FormControl>
            </Box>
          </Box>

          <Box
            // border={1} // Adds a border around the box
            // borderRadius={4} // Optional: adds rounded corners to the border
            // borderColor="grey.400" // Sets the color of the border
            padding={2} // Adds some padding inside the box
            marginTop={2}
          >
            <Typography className="v-block-footer mb-2">Select the duration for your AI Summary (in secs)</Typography>

            <Box display="flex" alignItems="center" paddingY={2}>
              <Slider
                value={Number(aiSummaryDuration.toFixed(2))}
                min={0}
                max={projectMaxDuration} // Assuming count is based on words array
                onChange={handleDurationSliderChange}
                variant="standard" // Use "standard" to minimize the border appearance
                valueLabelDisplay="auto"
                style={{ flex: 1 }}
              />

              <TextField
                value={`${aiSummaryDuration.toFixed(2)}/${projectMaxDuration.toFixed(2)}`}
                onChange={handleInputChange}
                variant="outlined"
                label="Duration(secs)"
                size="small"
                style={{ width: 100, marginLeft: 16 }}
                inputProps={{
                  readOnly: true,
                  style: {
                    textAlign: 'center', // Center the text horizontally
                    fontSize: '0.875rem', // Set the font size
                    padding: 0, // Remove any padding from the input
                    height: '1.0rem', // Ensure a consistent height for the input
                    display: 'flex', // Use flexbox for alignment
                    alignItems: 'center', // Vertically center the text
                    justifyContent: 'center', // Horizontally center the text
                    lineHeight: '1.0rem', // Ensure the line height matches the height
                    border: 'none', // Remove the border
                  },
                }}
                InputProps={{
                  style: {
                    height: '2.0rem', // Match the height to the input for consistency
                    padding: 0, // Remove extra padding
                    display: 'flex', // Flexbox for alignment
                    alignItems: 'center', // Vertically center the content
                    border: 'none', // Remove the border
                  },
                }}
              />
            </Box>
          </Box>

          <Box display={'flex'} flexDirection={"column"}>
            <Button
              disabled={!language || !sumaryTxtLang}
              className="mt-10"
              variant="contained"
              size='medium'
              endIcon={<AutoFixHighIcon />}
              onClick={() => {
                createSubtitleStr(false)
              }}
            >
              Create AI Summary
            </Button>
            <Button
              className="mt-10"
              variant="outlined"
              size='medium'
              endIcon={<CloseIcon />}
              onClick={handleCloseCreateAISummaryModal}
            >
              Close
            </Button>
          </Box>

        </Box>
      </Modal>
      {/* Create AI Summary Modal End */}

      {/* Create AI Shorts Modal Start */}
      <Modal
        open={openCreateAIShortsModal}
        onClose={handleCloseCreateAIShortsModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          border: '2px solid #000',
          borderRadius: 4,
          boxShadow: 24,
          p: { xs: 2, sm: 3, md: 4 }, // responsive padding
          width: { xs: '90%', sm: 500, md: 600 } // responsive width
        }}>
          <Typography variant='h4' align='center' gutterBottom>Select AI Shorts Options</Typography>

          <Box className='p-2'>
            <Box className='v-autocomplate pt-2'>
              <FormControl>
                <InputLabel id='select-language-detect'>{languageStrs.select_language_detect}</InputLabel>

                <Select
                  value={language}
                  //inputProps={{ 'aria-label': 'Without label' }}
                  //className='v-hoverborder v-radius v-commonboxheight'
                  onChange={languageChange}
                  labelId='select-language-detect'
                >
                  {languageToList1.map((option, key) =>
                    <MenuItem value={option.key} key={key}>
                      <Typography
                        component='span'
                      >
                        {option.label}
                      </Typography>
                    </MenuItem>
                  )}
                </Select>
              </FormControl>
            </Box>
          </Box>

          <Box className='p-2'>
            <Box className='v-autocomplate pt-4'>
              <FormControl>
                <InputLabel id='summarize-content'>Translate subtitles to . . .</InputLabel>

                <Select
                  value={sumaryTxtLang}
                  // inputProps={{ 'aria-label': 'Without label' }}
                  // className='v-hoverborder v-radius v-commonboxheight'
                  onChange={({ target }) => {
                    const langKey = target.value;
                    const langLabel = languageToList1.find(lang => lang.key === langKey)?.label;
                    setSumaryTxtLang(langKey);
                    setSumaryTxt(`Translate subtitles to ${langLabel}`);
                  }}
                  labelId='summarize-content'
                >
                  {languageToList1.map((option, key) =>
                    <MenuItem value={option.key} key={key}>
                      <Typography
                        component='span'
                      >
                        {option.label}
                      </Typography>
                    </MenuItem>
                  )}
                </Select>
              </FormControl>
            </Box>
          </Box>

          <Box
            padding={2}
          >
            <Typography className="v-block-footer mb-2">Set the minimum clip duration (in seconds)</Typography>

            <Box display="flex" alignItems="center" paddingY={1}>
              <Slider
                // disabled={ProjectJSON?.duration < 60000}
                value={Number(aiShortsDuration.toFixed(2))}
                min={15}
                max={60}
                step={1}
                onChange={handleShortsDurationSliderChange}
                variant="standard"
                valueLabelDisplay="auto"
                style={{ flex: 1 }}
              />
            </Box>
          </Box>

          <Box
            padding={2}
          >
            <Typography className="v-block-footer mb-2">Set the number of total chapters</Typography>

            <Box display="flex" alignItems="center" paddingY={1}>
              <Slider
                // disabled={ProjectJSON?.duration < 60000}
                value={aiShortsNumber}
                min={1}
                max={150}
                step={1}
                onChange={handleShortsNumberSliderChange}
                variant="standard"
                valueLabelDisplay="auto"
                style={{ flex: 1 }}
              />
            </Box>
          </Box>

          <Box display={'flex'} flexDirection={"column"}>
            <Button
              style={{ width: "100%" }}
              variant='contained'
              onClick={() => setShowMoreOptions(!showMoreOptions)}
              sx={{ mt: 1, mb: 1 }}
            >
              {showMoreOptions === false ? <TuneIcon /> : <CloseIcon />}
              MORE OPTIONS
            </Button>
            <Collapse in={showMoreOptions} timeout={300}>

              <Box display="flex" gap={4} justifyContent="center">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={hasPart}
                      onChange={(e) => setHasPart(e.target.checked)}
                    />
                  }
                  label="Include Part Numbers"
                  sx={{ display: "flex", alignItems: "center" }}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={hasTitle}
                      onChange={(e) => setHasTitle(e.target.checked)}
                    />
                  }
                  label="Include Project Title"
                  sx={{ display: "flex", alignItems: "center" }}
                />
              </Box>
              
              <Box
                padding={2}
                marginTop={2}
              >
                <Tooltip title="Silence setting is used to detect the silences between words and create chapters based on the silence duration.">
                  <Typography className="v-block-footer mb-2">Set the silence threshold (in seconds)</Typography>
                </Tooltip>
                <Box
                  mt={2}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: "0.75rem",
                    paddingX: 1,
                  }}
                >
                  <Box
                    textAlign="center"
                    sx={{
                      color: "rgba(0, 0, 0, 1)",
                      textShadow: "0 0 5px #00eeffff, 0 0 10px #00eeffff, 0 0 20px #00eeffff",
                    }}
                  >
                    <strong>News</strong>
                    <br />
                    <strong>0.3–0.5 sec</strong>
                  </Box>

                  <Box
                    textAlign="center"
                    sx={{
                      color: "#000000ff",
                      textShadow: "0 0 5px #00eeffff, 0 0 10px #00eeffff, 0 0 20px #00eeffff",
                    }}
                  >
                    <strong>Movie</strong>
                    <br />
                    <strong>3–4 sec</strong>
                  </Box>

                  <Box
                    textAlign="center"
                    sx={{
                      color: "#000000ff",
                      textShadow: "0 0 5px #00eeffff, 0 0 10px #00eeffff, 0 0 20px #00eeffff",
                    }}
                  >
                    <strong>TV Series</strong>
                    <br />
                    <strong>4+ sec</strong>
                  </Box>
                </Box>


                <Box display="flex" alignItems="center" paddingY={2}>
                  <Typography variant='subtitle2' className="v-block-footer mr-2 text-center">More<br />Chapters</Typography>
                  <Slider
                    //disabled={ProjectJSON?.duration < 60000}
                    value={Number(aiSummarySilence.toFixed(2))}
                    min={0.3}
                    max={10}
                    step={0.1}
                    onChange={handleSilenceDetectionSliderChange}
                    variant="standard"
                    valueLabelDisplay="auto"
                    style={{ flex: 1 }}
                  />
                  <Typography variant='subtitle2' className="v-block-footer ml-2 text-center">Less<br />Chapters</Typography>
                </Box>
              </Box>
            </Collapse>

          </Box>

          <Box display={'flex'} flexDirection={"column"}>
            <Button
              disabled={!language || !sumaryTxtLang}
              className="mt-10"
              variant="contained"
              size='medium'
              endIcon={<AppShortcutIcon />}
              onClick={() => {
                createShortSubtitleStr(false)
                }}
              >
                Create AI Short
              </Button>
              <Button
                className="mt-10"
                variant="outlined"
                size="medium"
                endIcon={<CloseIcon />}
                onClick={handleCloseCreateAIShortsModal}
              >
                Close
              </Button>

              {/* Define the constant for clarity */}
              <Box sx={{ mt: 2 }}>
                <Tooltip 
                  title={isTooLong ? `Video is ${durationInMinutes} minutes. Max 5 minutes allowed for single Reel.` : ""}
                  followCursor // Optional: makes the hint follow the mouse
                  arrow
                >
                  {/* Wrapping in a span allows the Tooltip to trigger even when the button is disabled */}
                  <span>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="secondary"
                      disabled={isTooLong}
                      startIcon={<AppShortcutIcon />}
                      onClick={handleDirectAIShortExport}
                      sx={{
                        textTransform: "none",
                        borderRadius: "8px",
                        fontWeight: "bold",
                        padding: "10px",
                        // Standard MUI disabled styles will handle the "graying out"
                      }}
                    >
                      Export Full Video as Reel
                    </Button>
                  </span>
                </Tooltip>
              </Box>

              </Box>
            </Box>
            </Modal>
            {/* Create AI Shorts Modal End */}

      {/* Regenerate Transcript Modal Start */}
      <Modal
        open={openRegenerateTranscriptionModal}
        onClose={handleCloseRegenerateTranscriptionModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          border: '2px solid #000',
          borderRadius: 4,
          boxShadow: 24,
          p: { xs: 2, sm: 3, md: 4 }, // responsive padding
          width: { xs: '90%', sm: 500, md: 600 } // responsive width
        }}>
          <Typography variant='h4' align='center' gutterBottom>Select Transcript Options</Typography>

          <Typography variant='body' align='center' gutterBottom>Existing transcript will be deleted in this process!</Typography>

          <Box className='p-2'>
            <Box className='v-autocomplate pt-2 mt-10'>
              <FormControl>
                <InputLabel id='select-language-detect'>{languageStrs.select_language_detect}</InputLabel>

                <Select
                  value={language}
                  //inputProps={{ 'aria-label': 'Without label' }}
                  //className='v-hoverborder v-radius v-commonboxheight'
                  onChange={languageChange}
                  labelId='select-language-detect'
                >
                  {languageToList1.map((option, key) =>
                    <MenuItem value={option.key} key={key}>
                      <Typography
                        component='span'
                      >
                        {option.label}
                      </Typography>
                    </MenuItem>
                  )}
                </Select>
              </FormControl>
            </Box>
          </Box>

          <Box display={'flex'} flexDirection={"column"}>
            <Button
              disabled={!language}
              className="mt-10"
              variant="contained"
              size='medium'
              endIcon={<TextSnippetIcon />}
              onClick={regenerateTranscript}
            >
              Regenerate Transcript
            </Button>

            <Button
              className="mt-10"
              variant="outlined"
              size='medium'
              endIcon={<CloseIcon />}
              onClick={handleCloseRegenerateTranscriptionModal}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
      {/* Regenerate Transcript Modal End */}

    <SummaryModal
      modalOpen={modalOpen}
      onModalCancel={onModalCancel}
      onModalConfirm={onModalConfirm}
      modalData={modalData}
      videolink={showVideoPath}
      intendedDuration={aiSummaryDuration}
      silenceSetting={aiSummarySilence}
      isAiSummaryModalActivated={isAiSummaryModalActivated}
      setIsAiSummaryModalActivated={setIsAiSummaryModalActivated}
    />

    <AiShortModal 
      modalOpen={shortModalOpen}
      onModalCancel={onAiShortCancel}
      modalData={modalData}
      subtitleData={existSubtitleWords}
      subtitleUUID={subtitleUUID}
      isAiShortModalActivated={isAiShortModalActivated}
      setIsAiShortModalActivated={setIsAiShortModalActivated}
      isDirectAIShort={isDirectAIShort}
      aiShortsDuration={aiShortsDuration}
      textWithDetails={textWithDetails}
      languageInitials={languageKey}
      subtitlesTargetLanguage={sumaryTxtLang}
      assetUUID={assetUUID}
      aiShortsNumber={aiShortsNumber}
      hasPart={hasPart}
      hasTitle={hasTitle}
    />

    <PricingModal open={showPricingPageModal} onCloseModal={handleClosePricingModal} />
    </>
  )
} 

